module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id=\'xOverlayMessaging\' class=\'xElement xTypeMessaging\'>\n    <div class="xMessagingContent">\n        '+
((__t=( messageText ))==null?'':__t)+
'\n    </div>\n</div>';
}
return __p;
};
